class AlgoliaStatsDetails extends HTMLElement {
  constructor() {
    super();

    this.connectedCallback = this.connectedCallback.bind(this);
    this.createWidget = this.createWidget.bind(this);
    this.render = this.render.bind(this);
    this.renderCollectionContent = this.renderCollectionContent.bind(this);
    this.renderContainer = this.renderContainer.bind(this);
    this.renderSearchResultsContent = this.renderSearchResultsContent.bind(this);
    this.renderSearchResultsNoContent = this.renderSearchResultsNoContent.bind(this);
  }

  /**
   * Initializes settings based on custom attributes when the element is connected to the DOM.
   * @returns {void}
   */
  connectedCallback() {
    this.settings = {
      collectionDescription: this.getAttribute('collection-description'),
      collectionTitle: this.getAttribute('collection-title'),
      noResultsText: this.getAttribute('no-results-text'),
      searchFor: this.getAttribute('search-for'),
      sectionTitle : this.getAttribute('section-title'),
      showCollectionDescription: this.getAttribute('show-collection-description').toLowerCase() === 'true'
    }
  }

  /**
   * Creates an instance of the stats widget.
   * @param {Object} configuration - Configuration object for rendering.
   * @param {Object} instances - Instances object containing algolia instances.
   * @returns {Object} The created stats widget instance.
   */
  createWidget(configuration, instances) {
    const { connectStats } = instances.instantSearch.connectors;
    const connectedStats = connectStats((renderOptions, isFirstRender) => this.render(configuration, isFirstRender, renderOptions));

    const selector = `.${configuration.container}`;
    const container = document.querySelector(selector);

    const statsDetailsWidget = connectedStats({ container });
    return statsDetailsWidget;
  }

  /**
   * Renders the stats widget with the provided render options.
   * @param {Object} configuration - Configuration object for rendering.
   * @param {boolean} isFirstRender - Indicates whether this is the first render.
   * @param {Object} renderOptions - Options for rendering the widget.
   * @returns {void}
   */
  render(configuration, isFirstRender, renderOptions) {
    if (isFirstRender) return;

    const { areHitsSorted, nbHits, nbSortedHits, widgetParams } = renderOptions;
    const { container } = widgetParams;

    const search = new URLSearchParams(window.location.search);
    const query = search.get('q');
    const isInCollection = !query;
    container.innerHTML = '';
    if (isInCollection) return container.appendChild(this.renderCollectionContent(configuration));

    const hits = areHitsSorted ? nbSortedHits : nbHits;

    const mobileFacetsWrappers = document.querySelectorAll('.mobile-facets__wrapper');
    mobileFacetsWrappers.forEach(wrapper => {
      wrapper.style.display = hits ? '' : 'none';
    });

    const content = hits ? this.renderSearchResultsContent(configuration, query) : this.renderSearchResultsNoContent(configuration, query);

    container.appendChild(content);
  }

  /**
   * Renders the collection results.
   * @param {Object} configuration - Configuration object for rendering.
   * @returns {string} The rendered collection results HTML.
   */
  renderCollectionContent(configuration) {
    // <div class="${classNames} collection-hero__text-wrapper">
    //   <h1 class="collection-hero__title">
    //     <span class="visually-hidden">${this.settings.sectionTitle}: </span>
    //     ${this.settings.collectionTitle}
    //   </h1>
    //   ${this.settings.showCollectionDescription ? `
    //     <div class="collection-hero__description rte">${this.settings.collectionDescription}</div>`
    //   : ""}
    // </div>
    const classNames = configuration.isMobile ? 'large-up-hide' : null;

    const div = document.createElement('div');
    if (classNames) div.classList.add(classNames);
    div.classList.add('collection-hero__text-wrapper');

    const h2 = document.createElement('h2');
    h2.classList.add('collection-hero__title');

    const span = document.createElement('span');
    span.classList.add('visually-hidden');
    span.textContent = `${this.settings.sectionTitle}: `;
    h2.appendChild(span);

    const title = document.createTextNode(this.settings.collectionTitle);
    h2.appendChild(title);
    div.appendChild(h2);
    return div;
  }

  /**
   * Renders the container for the stats widget.
   * @param {Object} configuration - Configuration object for rendering.
   * @param {Function} html - The HTML template function.
   * @returns {string} The rendered container.
   */
  renderContainer(configuration, html) {
    return html`<div class="${configuration.container}"></div>`;
  }

  /**
   * Renders the search results content.
   * @param {Object} configuration - Configuration object for rendering.
   * @param {string} query - The searched query.
   * @returns {string} The rendered search results content HTML.
   */
  renderSearchResultsContent(configuration, query) {
    const classNames = `template-search__header ${configuration.isMobile ? 'large-up-hide' : ''}`;
    const title = this.settings.searchFor.replace('terms', query);
    const h1 = document.createElement('h1');
    const div = document.createElement('div');
    div.setAttribute('class', classNames);
    h1.appendChild(document.createTextNode(title));
    div.appendChild(h1);
    return div;
  }

  /**
   * Renders the search results no content.
   * @param {Object} configuration - Configuration object for rendering.
   * @param {string} query - The searched query.
   * @returns {string} The rendered search results no content HTML.
   */
  renderSearchResultsNoContent(configuration, query) {
    const classNames = `template-search__no_results ${configuration.isMobile ? 'large-up-hide' : ''}`;
    const title = `${this.settings.noResultsText} "${query}"`;
    const h1 = document.createElement('h1');
    const div = document.createElement('div');
    div.setAttribute('class', classNames);
    h1.appendChild(document.createTextNode(title));
    div.appendChild(h1);
    return div;
  }
}

customElements.define("algolia-stats-details", AlgoliaStatsDetails);